import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import css from './appointment-type-modal.css'
import CancelableChip from '../../../sitewide/Chips/CancelableChip'
import SelectableChip from '../../../sitewide/Chips/SelectableChip'

const ModalContent = ({
  appointmentTypes,
  handleAddType,
  handleAddAllOfType,
  handleClearAllOfType,
  handleRemoveType,
  handleSearch,
  page,
  patientStatuses,
  searchTerm,
  selectedAppointmentTypeIds,
  selectedPatientStatusIds,
}) => {
  const selectedApptTypes = appointmentTypes.filter(type =>
    selectedAppointmentTypeIds.includes(type.id),
  )

  const selectedPatientStatuses = patientStatuses.filter(status =>
    selectedPatientStatusIds.includes(status.id),
  )

  const filterByTerm = obj => (
    (obj.code && obj.code.toLowerCase().includes(searchTerm.toLowerCase()))
      || (obj.description && obj.description.toLowerCase().includes(searchTerm.toLowerCase()))
  )

  const pageContent =
    page === 0
      ? {
        addableTypes: appointmentTypes.filter(filterByTerm).map(type => (
          <SelectableChip
            key={type.id}
            description={type.description}
            handleAddChip={handleAddType}
            id={type.id}
            title={type.code}
            type="tempSelectedAppointmentTypeIds"
            usedChipTypes={selectedAppointmentTypeIds}
          />
          )),
        allTypesSelected:
            appointmentTypes.length === selectedAppointmentTypeIds.length,
        cancelableTypes: selectedApptTypes.map(apptType => (
          <CancelableChip
            key={apptType.id}
            description={apptType.description}
            handleRemoveChip={handleRemoveType}
            id={apptType.id}
            title={apptType.code}
            type="tempSelectedAppointmentTypeIds"
          />
          )),
        handleAddAllOfType: () =>
            handleAddAllOfType('tempSelectedAppointmentTypeIds'),
        handleClearAllOfType: () =>
            handleClearAllOfType('tempSelectedAppointmentTypeIds'),
        selectAllButtonClasses: cx(css.button, css.toggleButton, {
          [`${css.remove}`]:
              appointmentTypes.length === selectedAppointmentTypeIds.length,
        }),
        title: 'Appointment Types',
      }
      : {
        addableTypes: patientStatuses.filter(filterByTerm).map(status => (
          <SelectableChip
            key={status.id}
            description={status.description}
            handleAddChip={handleAddType}
            id={status.id}
            title={status.code}
            type={'tempSelectedPatientStatusIds'}
            usedChipTypes={selectedPatientStatusIds}
          />
          )),
        allTypesSelected:
            patientStatuses.length === selectedPatientStatusIds.length,
        cancelableTypes: selectedPatientStatuses.map(status => (
          <CancelableChip
            key={status.id}
            description={status.description}
            handleRemoveChip={handleRemoveType}
            id={status.id}
            title={status.code}
            type="tempSelectedPatientStatusIds"
          />
          )),
        handleAddAllOfType: () =>
            handleAddAllOfType('tempSelectedPatientStatusIds'),
        handleClearAllOfType: () =>
            handleClearAllOfType('tempSelectedPatientStatusIds'),
        selectAllButtonClasses: cx(css.button, css.toggleButton, {
          [`${css.remove}`]:
              patientStatuses.length === selectedPatientStatusIds.length,
        }),
        title: 'Patient Statuses',
      }

  return (
    <div className={css.contentContainer}>
      <div>
        <span
          className={css.contentTitle}
        >{`Selected ${pageContent.title}`}</span>
        <div className={css.chipContainer}>
          <div className={css.chipScrollBox}>
            {!!pageContent.cancelableTypes.length &&
              pageContent.cancelableTypes}
          </div>
        </div>
      </div>
      <span className={css.contentTitle}>{`All ${pageContent.title}`}</span>
      <div className={css.rowAboveChips}>
        <div className={css.buttonContainer}>
          <button
            className={pageContent.selectAllButtonClasses}
            onClick={
              pageContent.allTypesSelected
                ? pageContent.handleClearAllOfType
                : pageContent.handleAddAllOfType
            }
          >
            {
              `${
                pageContent.allTypesSelected ? 'Remove' : 'Add'
              } all ${
                pageContent.title.split(' ').pop().toLowerCase()
              }`
            }
          </button>
        </div>
        <div className={css.searchFilter}>
          <label htmlFor="search">Search:</label>
          <input
            type="text"
            name="search"
            onChange={handleSearch}
            value={searchTerm}
          />
        </div>
      </div>
      <div className={css.chipContainer}>
        <div className={css.chipScrollBox}>
          {!!pageContent.addableTypes.length && pageContent.addableTypes}
        </div>
      </div>
    </div>
  )
}

ModalContent.propTypes = {
  appointmentTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleAddAllOfType: PropTypes.func.isRequired,
  handleAddType: PropTypes.func.isRequired,
  handleClearAllOfType: PropTypes.func.isRequired,
  handleRemoveType: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  patientStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchTerm: PropTypes.string.isRequired,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ModalContent



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/BlastMessageFiltersModal/ModalContent.js